import { exportToExcel } from '../../../../designSystem/DataExporter/utils/exportToExcel';
import getPaymentMethod from './paymentMethods';

export const handleExportBancoDeChileXLSX = async (
  payments: any,
  id: any,
  message?: string,
) => {
  const messsage = message || `Operación ${id}`;
  const headers = [
    { key: 'paymentMethod', label: 'MEDIO DE PAGO*' },
    { key: 'identifier', label: 'RUT BENEFICIARIO*' },
    {
      key: 'verifierDigit',
      label: 'DÍGITO VERIFICADOR RUT BENEFICIARIO*',
    },
    { key: 'name', label: 'NOMBRE BENEFICIARIO*' },
    {
      key: 'bankCode',
      label: 'CÓDIGO BANCO*',
    },
    {
      key: 'bankAccount',
      label: 'NÚMERO CUENTA*',
    },
    {
      key: 'amount',
      label: 'MONTO PAGO*',
    },
    { key: 'description', label: 'DESCRIPCIÓN PAGOS' },
    {
      key: 'email',
      label: 'MAIL DE DESTINO PARA AVISO',
    },
    { key: 'message', label: 'MENSAJE' },
  ];

  const data = payments.map((x: any) => {
    const identifier = x.bankAccountDestinationHolderIdentifier.split('-');
    return {
      paymentMethod: getPaymentMethod(x),
      identifier: identifier[0],
      verifierDigit: identifier[1],
      name: x.bankAccountDestinationHolderName,
      bankCode: x.bankAccountDestinationBankCode,
      bankAccount: x.bankAccountDestinationNumber,
      amount: x.amount,
      description: messsage,
      email: x.bankAccountDestinationHolderEmail,
      message: messsage,
    };
  });

  await exportToExcel(
    data,
    headers,
    `Banco_de_chile_${id}_${payments[0].bankAccountDestinationHolderName}.xlsx`,
  );
};
